import { requestImagePickerPermissions } from "@utils/permissions";

/**
 * Requests camera + storage permissions for the image picker.
 * Resolves on success, rejects with a string message on denial.
 */
const checkPermissions = async () => {
  const { granted } = await requestImagePickerPermissions();
  if (granted) return;
  throw new Error("permissions not granted");
};

export default checkPermissions;
